import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { DashboardModuleGuard } from './guards/dashboard-module.guard';
import { TransactionProcessingComponent } from './click-it/create-order/cement/payment/transaction-processing/transaction-processing.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('../app/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('../app/click-it/click-it.module').then((m) => m.ClickItModule),
    canLoad: [DashboardModuleGuard],
  },
  {
    path: 'processing',
    component: TransactionProcessingComponent,
  },
];
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
